import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ProfileModalService {
  private readonly modalOpenSubject = new Subject<void>();
  private readonly profileModalOpenSubject = new Subject<void>();

  modalOpen$ = this.modalOpenSubject.asObservable();
  profileModalOpen$ = this.profileModalOpenSubject.asObservable();

  openAboutModal(): void {
    this.modalOpenSubject.next();
  }

  openProfileModal(): void {
    this.profileModalOpenSubject.next();
  }
}
